var UNDEFINED = "undefined";

export default function defined(value) {
    return typeof value !== UNDEFINED;
}


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/util/defined.js
// module id = ../../../../@progress/kendo-drawing/dist/es/util/defined.js
// module chunks = vendor